import { css, cx } from "@styled-system/css";

type Props = {
  bg?: string;
  Icon: any;
  size?: number;
  iconFill?: string;
  bgOnHover?: string;
  className?: string;
  onClick?: () => void;
};

export function IconAsButton({
  onClick,
  Icon,
  iconFill = "primary",
  bg = "transparent",
  bgOnHover = "primaryTransparent",
  className,
  size = 24
}: Props) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cx(
        css({
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: `${size}px`,
          height: `${size}px`,
          minWidth: `${size}px`,
          minHeight: `${size}px`,
          maxWidth: `${size + size / 3}px`,
          maxHeight: `${size + size / 3}px`,
          borderRadius: "100%",
          p: "1rem",
          cursor: "pointer",
          transition: "all 0.3s",
          bg,
          _hover: {
            bg: bgOnHover
          },
          _active: {
            bg: "transparent"
          }
        }),
        className
      )}
    >
      <Icon
        className={css({
          fill: iconFill,
          width: `${size}px`,
          height: `${size}px`,
          minWidth: `${size}px`,
          minHeight: `${size}px`
        })}
      />
    </button>
  );
}
